import { object } from 'yup'

import { i18nErrorCodes }              from '../form-utils'
import { emailSchema, passwordSchema } from './formatSchemas'

const { required } = i18nErrorCodes

export default object().shape({
  email:    emailSchema.required(required),
  password: passwordSchema.required(required),
})

export const emptyCredentials = {
  email:    '',
  password: '',
}



// WEBPACK FOOTER //
// ./src/components/forms/schemas/credentials.schema.ts